import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { usePurchasePoDetailsModel } from "../scmPurchasePoModel";
import { formatNum } from "@/utils/utils";
import { YhBox } from '@/components/YhBox';
// import { DictCodeEnmu } from "@/types/ScmDictEnums";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { lookDesc, lookFormVal } = usePurchasePoDetailsModel();
    const { cm } = useGlobalModel();
    const newFormVal = lookFormVal;

    const retuenText = (field: string, money: boolean = false, field2?: string) => {//field2为买赠时传入的字段
        let desc = lookDesc;
        return money ? `￥${formatNum(field2 ? desc[field] + desc[field2] : desc[field])}` : field2 ? desc[field] + desc[field2] : desc[field];
    }
    const orderStatistics: IDescription[] = [
        {
            label: "开单量",
            value: retuenText("numAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "损坏",
            value: retuenText("damageAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "赠品",
            value: retuenText("giftsAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "种类",
            value: retuenText("kindAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "已入库",
            value: retuenText("stockInAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "驳回",
            value: retuenText("rejectAll"),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "总计",
        //     value: retuenText("amountAll", true),
        //     color: DescriptionColorEnum.red,
        //     status: true
        // },
        newFormVal.preferentialTypeCode === 'preferential_type.link-gift' ? {
            label: "总计",//单赠类型的
            value: retuenText("giftsAmount", true),
            color: DescriptionColorEnum.red,
            status: true
        } : newFormVal.preferentialTypeCode === 'preferential_type.buy-gift' ? {
            label: "总计",//买赠类型的 单赠+销售
            value: retuenText("giftsAmount", true, 'actualAmount'),
            color: DescriptionColorEnum.red,
            status: true
        } : {
            label: "总计",//以上俩个类型除外的
            value: retuenText("actualAmount", true),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "入库总计",
            value: retuenText("settleAmountAll", true),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}